import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import CONSTANT from './../../../shared/constants/constant';
import Util from './../../../shared/util/util';
import DatePicker from 'vue2-datepicker';
import moment from "moment";
import XLSX from 'xlsx';
export default {
    name: 'expiryebn',
    components: {
        DatePicker,
        CustomExpandableTable,
        Util,
        Utility,
        Loader
    },
    data: function () {
        return {
            totalCount: 0,
            offset: 0,
            date: new Date(),
            disabledAfter:new Date(),
            isLoading:false,
            tableColumn: [ 'AWB','Invoice Number','EwaybillSRNumber','EbnExpirydate','FromPlace','FromStateCode','FromState','Frompincode','AddressLine1','AddressLine2','AddressLine3'],
             innerTableColumn: ['Assigned Territory'],
             tableItems: [],
        }
    },
    computed: {

    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userName = userdetail.email;
        this.getEBNListing();
    },
    methods: {
        clearForm() {
          this.date = new Date();
          this.getEBNListing();
          this.$validator.reset();
        },
     
        getCustomTableEvent(event) {

        },
        async getEBNListing() {
            try {
                this.isLoading = true;
                let inputPayload = {}
                if (this.date) {
                    inputPayload.date = moment(this.date).tz('Asia/Kolkata').format('YYYY-MM-DD');
                }
                let result = await Utility.getEbnListingdata(inputPayload)
                if (result.data.code == 200) {
                    this.isLoading = false;
                    this.tableItems = result.data.data.data.map((el) => {
                        return {
                            'id': 1,
                            'AWB': el.parentawbno,
                            'Invoice Number': el.invoiceno,
                            'EwaybillSRNumber': el.ewaybillsrnumber,
                            'EbnExpirydate': el.ebnexpirydate,
                            'FromPlace': el.fromPlace,
                            'FromState': el.fromState,
                            'Frompincode': el.frompincode,
                            'AddressLine1': el.addressLine1,
                            'AddressLine2': el.addressLine2,
                            'AddressLine3': el.addressLine3,
                            'Action': 'Need To Check1'
                        } 
                    })
                    this.totalCount = result.data.data.count;           
                    this.isLoading = false
                } else {
                    this.$alertify.error(result.data.message);
                    this.isLoading = false
                }
            } catch (err) {
                console.log(err);
            }
        },
        async downloadEbnList(){
            try {
              this.isLoading = true;
              let inputPayload = {}
              if (this.date) {
                  inputPayload.date = moment(this.date).tz('Asia/Kolkata').format('YYYY-MM-DD');
              }
              let result = await Utility.getEbnListingdata(inputPayload)
              if(result.data.data.count>0){
                let tempData = result.data.data.data.map((el)=>{
                    return {
                        'AWB': el.parentawbno,
                        'Invoice Number': el.invoiceno,
                        'EwaybillSRNumber': el.ewaybillsrnumber,
                        'EbnExpirydate': el.ebnexpirydate,
                        'FromPlace': el.fromPlace,
                        'FromState': el.fromState,
                        'Frompincode': el.frompincode,
                        'AddressLine1': el.addressLine1,
                        'AddressLine2': el.addressLine2,
                        'AddressLine3': el.addressLine3
                    } 
                });
                const data = XLSX.utils.json_to_sheet(tempData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, data, 'data')
                XLSX.writeFile(wb,'EBNExpiryData.xlsx');
              }else{
                this.$alert("No Ebn Expiry records to download", "EBNExpiry Data", "error");
              }
              this.isLoading = false;
            } catch(err){
              console.log(err);
              this.isLoading = false;
            }
          },
    }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/ebnexpirylist/ebnexpirylist.component.js